/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import "./bootstrap";
import { createApp } from "vue";
import VueSweetalert2 from "vue-sweetalert2";

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

import RolesEdit from "../../vendor/csgt/utils/src/resources/views/catalogs/RolesEdit.vue";
import RoleModule from "../../vendor/csgt/utils/src/resources/views/catalogs/RoleModule.vue";
import Profile from "../../vendor/csgt/utils/src/resources/views/Profile.vue";

import UsersEdit from "./pages/Catalogs/Users.vue";
import HomeIndex from "./pages/Home/HomeIndex.vue";
import HomeHowItWorks from "./pages/Home/HomeHowItWorks.vue";
import HomePricing from "./pages/Home/HomePricing.vue";
import EnvioMasivo from "./pages/EnvioMasivo.vue";
import Partidos from "./pages/Partidos.vue";
import QuinielaEdit from "./pages/QuinielaEdit.vue";
import ReporteCodigos from "./pages/ReporteCodigos.vue";

import StoreLinks from "./components/StoreLinks.vue";
import FilterMultiselect from "./components/FilterMultiselect.vue";

const app = createApp();
app.use(VueSweetalert2);

app.component("catalogs-roles-edit", RolesEdit);
app.component("catalogs-rolemodule", RoleModule);
app.component("catalogs-users-edit", UsersEdit);
app.component("profile", Profile);

app.component("EnvioMasivo", EnvioMasivo);
app.component("HomeIndex", HomeIndex);
app.component("HomeHowItWorks", HomeHowItWorks);
app.component("HomePricing", HomePricing);
app.component("Partidos", Partidos);
app.component("QuinielaEdit", QuinielaEdit);
app.component("ReporteCodigos", ReporteCodigos);

app.component("StoreLinks", StoreLinks);
app.component("filter-multiselect", FilterMultiselect);

app.mount("#app");
